import React, { useEffect } from "react";
import { CheckIcon } from "../../graphic/CheckIcon";
import styles from "./SiteStoryToast.scss";

// As long as the app's toasts are shown
const DURATION = 3500;

/**
 * Success message just below a story box (pass it as SiteStoryBox's `toast`), looking like the app's success toast.
 * It calls `onDone` when it has been shown; give it a new `key` to show it again.
 */
export const SiteStoryToast = ({ message, onDone }) => {
    useEffect(() => {
        const timer = setTimeout(() => onDone?.(), DURATION);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={styles.base} role="status">
            <div className={styles.icon}>
                <CheckIcon />
            </div>
            <div className={styles.message}>{message}</div>
        </div>
    );
};
